const BackfacingArrowsDiagonal = () => (
  <>
    <path
      fill="currentColor"
      d="M17.679 7.012v4.812q0 .213.144.356a.49.49 0 0 0 .357.144q.212 0 .356-.144a.49.49 0 0 0 .143-.356V6.132a.78.78 0 0 0-.232-.576.78.78 0 0 0-.576-.232H12.18a.48.48 0 0 0-.356.144.49.49 0 0 0-.144.357q0 .212.144.356a.49.49 0 0 0 .356.143h4.812l-5.123 5.123-.44.44-5.104 5.103V12.18a.48.48 0 0 0-.144-.357.49.49 0 0 0-.357-.143.48.48 0 0 0-.356.143.49.49 0 0 0-.143.357v5.692q0 .343.232.575a.78.78 0 0 0 .576.233h5.692q.212 0 .357-.144a.49.49 0 0 0 .143-.357.48.48 0 0 0-.143-.356.49.49 0 0 0-.357-.143H7.013l5.103-5.104.46-.46z"
    />
  </>
)
export default BackfacingArrowsDiagonal
